var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuysell2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 175,
    viewBox: "0 0 245 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M162.285 54.1213H87.7147V174.108H162.285V54.1213Z",
    fill: "#9D635C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M162.741 131.603H87.5417V174.165H162.741V131.603Z",
    fill: "#F2C69C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M162.741 132.361H87.5417V135.006H162.741V132.361Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M162.285 94.4693H87.7147V96.2676H162.285V94.4693Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M162.285 56.1074H87.7147V57.9057H162.285V56.1074Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M163.696 91.8247H86.3044V94.469H163.696V91.8247Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M163.603 48.4792H86.6793V54.1216H163.603V48.4792Z",
    fill: "#E6C2A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M164.26 166.208H85.7402V174.776H164.26V166.208Z",
    fill: "#653B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M164.26 166.174H85.7402V167.193H164.26V166.174Z",
    fill: "#84594C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M111.726 140.64H95.737V174.295H111.726V140.64Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M111.021 141.345V173.59H96.4422V141.345H111.021ZM112.432 139.935H111.022H96.4425H95.0322V141.345V173.59V175H96.4425H111.022H112.432V173.59V141.345V139.935Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M96.4424 141.404V142.391H96.4849V173.502H97.4721V142.391H110.035V173.502H111.022V142.391V141.534V141.404H96.4424Z",
    fill: "#F7E0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M163.603 48.9521H86.6793V49.7103H163.603V48.9521Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M164.26 53.463H86.0223V56.1074H164.26V53.463Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M164.26 46.3988H86.0223V49.0431H164.26V46.3988Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M91.3769 60.572H87.7147V63.2163H91.3769V60.572Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M99.5584 60.572H93.6392V63.2163H99.5584V60.572Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M139.421 83.6133H134.348V86.2576H139.421V83.6133Z",
    fill: "#BB7999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M116.808 60.572H110.889V63.2163H116.808V60.572Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M145.167 77.7624H139.248V80.4067H145.167V77.7624Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M133.557 69.1227H127.638V71.7671H133.557V69.1227Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.2,
    d: "M156.167 66.0198H150.248V68.6641H156.167V66.0198Z",
    fill: "#9C574F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    opacity: 0.3,
    d: "M138.857 98.4003H132.937V101.045H138.857V98.4003Z",
    fill: "#7B4061"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M145.167 114.343H139.248V116.987H145.167V114.343Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M137.308 123.705H131.388V126.349H137.308V123.705Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M155.322 123.511H151.74V126.155H155.322V123.511Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.2,
    d: "M116.631 124.075H110.712V126.719H116.631V124.075Z",
    fill: "#9C574F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M116.631 98.4003H110.712V101.045H116.631V98.4003Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M110.851 106.497H104.932V109.141H110.851V106.497Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M121.517 113.021H115.597V115.665H121.517V113.021Z",
    fill: "#BB7999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    opacity: 0.3,
    d: "M110.753 78.2906H104.834V80.9349H110.753V78.2906Z",
    fill: "#9C574F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M140.267 60.572H134.348V63.2163H140.267V60.572Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M90.2485 66.4784H87.7147V69.1227H90.2485V66.4784Z",
    fill: "#BB7999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M91.3769 72.3846H87.7147V75.0289H91.3769V72.3846Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M119.537 72.3846H115.875V75.0289H119.537V72.3846Z",
    fill: "#BB7999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M107.31 87.7701H101.391V90.4144H107.31V87.7701Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M90.2485 78.2906H87.7147V80.9349H90.2485V78.2906Z",
    fill: "#BB7999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M91.3769 84.197H87.7147V86.8413H91.3769V84.197Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M121.932 84.197H118.27V86.8413H121.932V84.197Z",
    fill: "#DC9087"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M162.177 60.572H158.515V63.2163H162.177V60.572Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M162.177 66.4784H159.925V69.1227H162.177V66.4784Z",
    fill: "#BB7999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M162.177 72.3846H158.515V75.0289H162.177V72.3846Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M162.177 78.2906H159.925V80.9349H162.177V78.2906Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M162.177 84.197H158.515V86.8413H162.177V84.197Z",
    fill: "#DC9087"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M91.3769 97.9464H87.7147V100.591H91.3769V97.9464Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M90.2485 103.853H87.7147V106.497H90.2485V103.853Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M133.132 103.853H130.598V106.497H133.132V103.853Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M155.742 103.853H153.208V106.497H155.742V103.853Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M91.3769 109.759H87.7147V112.403H91.3769V109.759Z",
    fill: "#BB7999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M90.2485 115.665H87.7147V118.309H90.2485V115.665Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M110.327 115.665H107.793V118.309H110.327V115.665Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M91.3769 121.571H87.7147V124.216H91.3769V121.571Z",
    fill: "#DC9087"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M162.177 97.9464H158.515V100.591H162.177V97.9464Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M162.177 103.853H159.643V106.497H162.177V103.853Z",
    fill: "#BB7999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M162.177 109.759H158.515V112.403H162.177V109.759Z",
    fill: "#DC9087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M162.177 115.665H159.643V118.309H162.177V115.665Z",
    fill: "#BB7999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M162.177 121.571H158.515V124.216H162.177V121.571Z",
    fill: "#DC9087"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M108.963 144.29H98.6156V166.209H108.963V144.29Z",
    fill: "#314A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    opacity: 0.2,
    d: "M98.6156 144.249L108.418 165.927H105.175L98.6156 151.327",
    fill: "#6C9FC5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M108.393 85.6176H95.7879V87.6395H108.393V85.6176Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M108.396 63.9231H95.7854V83.6898H108.396V63.9231Z",
    fill: "#E2B291"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M108.957 62.1007H95.2239V64.4168H108.957V62.1007Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M108.957 83.3016H95.2237V85.6177H108.957V83.3016Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M104.43 62.4097C104.736 61.1172 103.935 59.822 102.643 59.5168C101.35 59.2116 100.055 60.012 99.7499 61.3045C99.4447 62.597 100.245 63.8921 101.538 64.1973C102.83 64.5025 104.125 63.7021 104.43 62.4097Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    opacity: 0.3,
    d: "M100.904 61.8484C100.904 61.1929 101.435 60.6618 102.09 60.6618C102.746 60.6618 103.277 61.1929 103.277 61.8484C103.277 62.504 102.746 63.0351 102.09 63.0351C101.435 63.0351 100.904 62.504 100.904 61.8484Z",
    fill: "#4D4044"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M107.123 65.2036H97.0573V82.9738H107.123V65.2036Z",
    fill: "#314A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    opacity: 0.2,
    d: "M97.0573 65.7715L104.715 82.6917H101.471L97.0573 72.568V65.7715Z",
    fill: "#6C9FC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M106.559 65.4858V82.1275H97.6215V65.4858H106.559ZM107.688 64.4168H96.4933V83.2557H107.688V64.3573V64.4168H107.688Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M101.471 65.2036V82.4096L102.599 82.1275V65.4857L101.471 65.2036Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M107.253 75.8755H96.8173V77.0037H107.253V75.8755Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M107.253 69.9691H96.8173V71.0972H107.253V69.9691Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M107.688 65.0284H96.493L95.7879 64.4168H108.393L107.688 65.0284Z",
    fill: "#D1BC9D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    opacity: 0.3,
    d: "M108.957 63.8052H95.2237V64.4168H108.957V63.8052Z",
    fill: "#4D4044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M108.957 83.3016H95.2237V84.0208H108.957V83.3016Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M131.303 85.6176H118.698V87.6395H131.303V85.6176Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M131.306 63.9231H118.695V83.6898H131.306V63.9231Z",
    fill: "#E2B291"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M131.867 62.1007H118.134V64.4168H131.867V62.1007Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M131.867 83.3016H118.134V85.6177H131.867V83.3016Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M122.596 61.8484C122.596 60.5201 123.672 59.4438 125 59.4438C126.328 59.4438 127.405 60.5203 127.405 61.8484C127.405 63.1768 126.328 64.2531 125 64.2531C123.672 64.2531 122.596 63.1768 122.596 61.8484Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    opacity: 0.3,
    d: "M123.814 61.8484C123.814 61.1929 124.345 60.6618 125 60.6618C125.656 60.6618 126.187 61.1929 126.187 61.8484C126.187 62.504 125.656 63.0351 125 63.0351C124.345 63.0351 123.814 62.504 123.814 61.8484Z",
    fill: "#4D4044"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M130.033 65.2036H119.967V82.9738H130.033V65.2036Z",
    fill: "#314A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    opacity: 0.2,
    d: "M119.985 65.7715L127.642 82.6917H124.399L119.985 72.568",
    fill: "#6C9FC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M129.47 65.4858V82.1275H120.531V65.4858H129.47ZM130.598 64.4168H119.403V83.2557H130.598V64.3573V64.4168Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M124.381 65.2036V82.4096L125.509 82.1275V65.4857L124.381 65.2036Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M130.163 75.8755H119.728V77.0037H130.163V75.8755Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M130.163 69.9691H119.728V71.0972H130.163V69.9691Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M130.598 65.0284H119.403L118.698 64.4168H131.303L130.598 65.0284Z",
    fill: "#D1BC9D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    opacity: 0.3,
    d: "M131.867 63.8052H118.134V64.4168H131.867V63.8052Z",
    fill: "#4D4044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M131.867 83.3016H118.134V84.0208H131.867V83.3016Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M154.107 85.6176H141.502V87.6395H154.107V85.6176Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M154.11 63.9231H141.5V83.6898H154.11V63.9231Z",
    fill: "#E2B291"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M154.671 62.1007H140.938V64.4168H154.671V62.1007Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M154.671 83.3016H140.938V85.6177H154.671V83.3016Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M150.204 62.0476C150.314 60.724 149.33 59.5623 148.006 59.4527C146.683 59.3431 145.521 60.3273 145.411 61.6508C145.302 62.9744 146.286 64.1362 147.61 64.2457C148.933 64.3553 150.095 63.3712 150.204 62.0476Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    opacity: 0.3,
    d: "M146.618 61.8484C146.618 61.1929 147.149 60.6618 147.805 60.6618C148.46 60.6618 148.991 61.1929 148.991 61.8484C148.991 62.504 148.46 63.0351 147.805 63.0351C147.149 63.0351 146.618 62.504 146.618 61.8484Z",
    fill: "#4D4044"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M152.838 65.2036H142.771V82.9738H152.838V65.2036Z",
    fill: "#314A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    opacity: 0.2,
    d: "M142.789 65.7715L150.447 82.6917H147.203L142.789 72.8501",
    fill: "#6C9FC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M152.274 65.4858V82.1275H143.336V65.4858H152.274ZM153.402 64.4168H142.207V83.2557H153.402V64.3573V64.4168Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M147.185 65.2036V82.4096L148.314 82.1275V65.4857L147.185 65.2036Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M152.967 75.8755H142.532V77.0037H152.967V75.8755Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M152.967 69.9691H142.532V71.0972H152.967V69.9691Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M153.402 65.0284H142.207L141.502 64.4168H154.107L153.402 65.0284Z",
    fill: "#D1BC9D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    opacity: 0.3,
    d: "M154.671 63.8052H140.938V64.4168H154.671V63.8052Z",
    fill: "#4D4044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M154.671 83.3016H140.938V84.0208H154.671V83.3016Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M108.393 118.362H95.7879V120.384H108.393V118.362Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M108.396 97.514H95.7854V117.281H108.396V97.514Z",
    fill: "#E2B291"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M108.957 116.892H95.2237V119.208H108.957V116.892Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M107.123 98.7942H97.0573V116.564H107.123V98.7942Z",
    fill: "#314A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    opacity: 0.2,
    d: "M97.0573 99.3594L104.715 116.28H101.471L97.0573 106.438",
    fill: "#6C9FC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M106.559 99.0763V115.718H97.6215V99.0763H106.559ZM107.688 98.0076H96.4933V116.846H107.688V97.9481V98.0076H107.688Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M101.471 98.7942V116L102.599 115.718V99.0763L101.471 98.7942Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M107.253 109.466H96.8173V110.594H107.253V109.466Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M107.253 103.56H96.8173V104.688H107.253V103.56Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M108.957 116.892H95.2237V117.611H108.957V116.892Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M131.444 118.238H118.839V120.26H131.444V118.238Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M131.447 97.3896H118.837V117.156H131.447V97.3896Z",
    fill: "#E2B291"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M132.008 119.084H118.275V117.05L132.008 116.768V119.084Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M130.175 98.67H120.108V116.44H130.175V98.67Z",
    fill: "#314A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    opacity: 0.2,
    d: "M120.108 99.2379L127.766 116.158H124.522L120.108 106.316",
    fill: "#6C9FC5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.826 174.776V170.21H130.457V174.776",
    fill: "#5A494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.826 174.776V170.21H130.457V174.776",
    stroke: "#C78872",
    strokeWidth: 1.41036,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.716 174.776V170.21H153.347V174.776",
    fill: "#5A494E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.716 174.776V170.21H153.347V174.776",
    stroke: "#C78872",
    strokeWidth: 1.41036,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M129.611 98.9521V115.594H120.673V98.9521H129.611ZM130.739 97.8832H119.544V116.722H130.739V97.8237V97.8832Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M124.522 98.67V115.876L125.65 115.594V98.9521L124.522 98.67Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M130.304 109.342H119.869V110.47H130.304V109.342Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M130.304 103.435H119.869V104.564H130.304V103.435Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M132.008 116.768H118.275V117.487H132.008V116.768Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M154.107 118.362H141.502V120.384H154.107V118.362Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M154.11 97.514H141.5V117.281H154.11V97.514Z",
    fill: "#E2B291"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M154.671 116.892H140.938V119.208H154.671V116.892Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M152.838 98.7942H142.771V116.564H152.838V98.7942Z",
    fill: "#314A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    opacity: 0.2,
    d: "M142.789 99.3379L150.447 116.258H147.203L142.789 106.416",
    fill: "#6C9FC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M152.274 99.0763V115.718H143.336V99.0763H152.274ZM153.402 98.0076H142.207V116.846H153.402V97.9481V98.0076Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M147.185 98.7942V116L148.314 115.718V99.0763L147.185 98.7942Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M152.967 109.466H142.532V110.594H152.967V109.466Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M152.967 103.56H142.532V104.688H152.967V103.56Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M154.671 116.892H140.938V117.611H154.671V116.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M95.7854 98.1251H95.7879L96.493 98.7367H107.688L108.393 98.1251V97.5135H95.7854V98.1251Z",
    fill: "#D1BC9D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M118.838 98.0009H118.866L119.544 98.5886H130.738L131.416 98.0009H131.445V97.3893H118.838V98.0009Z",
    fill: "#D1BC9D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M141.5 97.5135V98.1251H141.528L142.206 98.713H153.4L154.078 98.1251H154.107V97.5135H141.5Z",
    fill: "#D1BC9D"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M164.542 130.281H85.4581V132.925H164.542V130.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M163.696 126.143H86.3039V130.281H163.696V126.143Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M154.334 161.55H141.729V163.572H154.334V161.55Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M157.157 139.855H138.905V142.698H157.157V139.855Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M156.029 144.192H140.034V147.035H156.029V144.192Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M157.157 148.529H138.905V151.372H157.157V148.529Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M156.029 152.866H140.034V155.709H156.029V152.866Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M157.157 157.203H138.905V160.045H157.157V157.203Z",
    fill: "#EFEEEA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M154.898 138.033H141.165V140.349H154.898V138.033Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M154.898 159.234H141.165V161.55H154.898V159.234Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M150.37 138.348C150.675 137.055 149.874 135.76 148.582 135.455C147.29 135.15 145.994 135.95 145.689 137.242C145.384 138.535 146.184 139.83 147.477 140.135C148.769 140.44 150.064 139.64 150.37 138.348Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M146.844 137.781C146.844 137.125 147.376 136.594 148.031 136.594C148.687 136.594 149.218 137.125 149.218 137.781C149.218 138.436 148.687 138.967 148.031 138.967C147.376 138.967 146.844 138.436 146.844 137.781Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M153.064 141.136H142.998V158.906H153.064V141.136Z",
    fill: "#314A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    opacity: 0.2,
    d: "M143.016 141.695L150.673 158.615H147.43L143.016 148.773",
    fill: "#6C9FC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M152.5 141.418V158.06H143.562V141.418H152.5ZM153.629 140.349H142.434V159.188H153.629V140.29V140.349Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M147.412 141.136V158.342L148.54 158.06V141.418L147.412 141.136Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M153.194 151.808H142.758V152.936H153.194V151.808Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M153.194 145.901H142.758V147.03H153.194V145.901Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M153.629 140.961H142.434L141.729 140.349H154.334L153.629 140.961Z",
    fill: "#D1BC9D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M154.898 159.234H141.165V159.953H154.898V159.234Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M131.444 161.55H118.839V163.572H131.444V161.55Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M134.268 139.855H116.016V142.698H134.268V139.855Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M133.139 144.192H117.144V147.035H133.139V144.192Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M134.268 148.529H116.016V151.372H134.268V148.529Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M133.139 152.866H117.144V155.709H133.139V152.866Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M134.268 157.203H116.016V160.045H134.268V157.203Z",
    fill: "#EFEEEA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M132.008 138.033H118.275V140.349H132.008V138.033Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M132.008 159.234H118.275V161.55H132.008V159.234Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M122.736 137.781C122.736 136.452 123.813 135.376 125.141 135.376C126.469 135.376 127.546 136.453 127.546 137.781C127.546 139.109 126.469 140.185 125.141 140.185C123.813 140.185 122.736 139.109 122.736 137.781Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M123.955 137.781C123.955 137.125 124.486 136.594 125.141 136.594C125.797 136.594 126.328 137.125 126.328 137.781C126.328 138.436 125.797 138.967 125.141 138.967C124.486 138.967 123.955 138.436 123.955 137.781Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M130.175 141.136H120.108V158.906H130.175V141.136Z",
    fill: "#314A56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    opacity: 0.2,
    d: "M120.126 141.695L127.783 158.615H124.539L120.126 148.773",
    fill: "#6C9FC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M129.611 141.418V158.06H120.673V141.418H129.611ZM130.739 140.349H119.544V159.188H130.739V140.29V140.349Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M124.522 141.136V158.342L125.65 158.06V141.418L124.522 141.136Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M130.304 151.808H119.869V152.936H130.304V151.808Z",
    fill: "#CE8067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M130.304 145.901H119.869V147.03H130.304V145.901Z",
    fill: "#CE8067"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M130.739 140.961H119.544L118.839 140.349H131.444L130.739 140.961Z",
    fill: "#D1BC9D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M132.008 159.234H118.275V159.953H132.008V159.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M119.544 140.349H119.081V159.234H119.544V140.349Z",
    fill: "#C78872"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M131.202 140.349H130.739V159.234H131.202V140.349Z",
    fill: "#C78872"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M110.933 142.749H96.4958L95.0319 141.264V140.64H112.432V141.264L110.933 142.749Z",
    fill: "#F7E0B8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M132.008 139.847H118.275V140.349H132.008V139.847Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M154.898 139.847H141.165V140.349H154.898V139.847Z",
    fill: "#EFEEEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M88.3682 126.425H87.15V130.28H88.3682V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M91.7538 126.425H90.5355V130.28H91.7538V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M95.1393 126.425H93.921V130.28H95.1393V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M98.5248 126.425H97.3065V130.28H98.5248V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M101.91 126.425H100.692V130.28H101.91V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M105.296 126.425H104.078V130.28H105.296V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M108.682 126.425H107.463V130.28H108.682V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M112.067 126.425H110.849V130.28H112.067V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M115.453 126.425H114.234V130.28H115.453V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M118.838 126.425H117.62V130.28H118.838V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M122.224 126.425H121.005V130.28H122.224V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M125.609 126.425H124.391V130.28H125.609V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M128.995 126.425H127.776V130.28H128.995V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M132.38 126.425H131.162V130.28H132.38V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M135.766 126.425H134.547V130.28H135.766V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M139.151 126.425H137.933V130.28H139.151V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M142.536 126.425H141.318V130.28H142.536V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M145.922 126.425H144.704V130.28H145.922V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M149.307 126.425H148.089V130.28H149.307V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M152.693 126.425H151.475V130.28H152.693V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M156.079 126.425H154.861V130.28H156.079V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M159.464 126.425H158.246V130.28H159.464V126.425Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M162.85 126.425H161.632V130.28H162.85V126.425Z",
    fill: "#F8E0CB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M88.3682 49.326H87.15V53.4628H88.3682V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M91.7538 49.326H90.5355V53.4628H91.7538V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M95.1393 49.326H93.921V53.4628H95.1393V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M98.5248 49.326H97.3065V53.4628H98.5248V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M101.91 49.326H100.692V53.4628H101.91V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M105.296 49.326H104.078V53.4628H105.296V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M108.682 49.326H107.463V53.4628H108.682V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M112.067 49.326H110.849V53.4628H112.067V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M115.453 49.326H114.234V53.4628H115.453V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M118.838 49.326H117.62V53.4628H118.838V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M122.224 49.326H121.005V53.4628H122.224V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M125.609 49.326H124.391V53.4628H125.609V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M128.995 49.326H127.776V53.4628H128.995V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M132.38 49.326H131.162V53.4628H132.38V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M135.766 49.326H134.547V53.4628H135.766V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M139.151 49.326H137.933V53.4628H139.151V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M142.536 49.326H141.318V53.4628H142.536V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M145.922 49.326H144.704V53.4628H145.922V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M149.307 49.326H148.089V53.4628H149.307V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M152.693 49.326H151.475V53.4628H152.693V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M156.079 49.326H154.861V53.4628H156.079V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M159.464 49.326H158.246V53.4628H159.464V49.326Z",
    fill: "#F8E0CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M162.85 49.326H161.632V53.4628H162.85V49.326Z",
    fill: "#F8E0CB"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    opacity: 0.6,
    d: "M163.696 126.349H86.3039V127.671H163.696V126.349Z",
    fill: "#E6C2A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M164.542 123.987H85.4581V126.631H164.542V123.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M111.022 140.211C110.561 140.211 110.129 140.013 109.828 139.674H97.4904C97.1895 140.014 96.7608 140.211 96.2981 140.211C95.4155 140.211 94.6975 139.493 94.6975 138.61C94.6975 137.727 95.4155 137.009 96.2981 137.009C96.918 137.009 97.4682 137.364 97.732 137.905H99.2122C99.9531 136.301 101.76 135.204 103.716 135.204C105.673 135.204 107.479 136.301 108.22 137.905H109.588C109.851 137.365 110.402 137.009 111.022 137.009C111.904 137.009 112.622 137.727 112.622 138.61C112.622 139.493 111.904 140.211 111.022 140.211Z",
    fill: "#F7E0B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M103.716 135.627C105.622 135.627 107.345 136.734 107.938 138.328H109.882C110.009 137.814 110.469 137.432 111.021 137.432C111.672 137.432 112.199 137.959 112.199 138.61C112.199 139.26 111.672 139.787 111.021 139.787C110.607 139.787 110.244 139.572 110.034 139.248V139.25H97.3004V139.22C97.0935 139.559 96.7236 139.787 96.2978 139.787C95.6475 139.787 95.1203 139.26 95.1203 138.61C95.1203 137.959 95.6475 137.432 96.2978 137.432C96.8504 137.432 97.3107 137.814 97.4376 138.328H99.4935C100.088 136.735 101.811 135.627 103.716 135.627ZM103.716 134.781C101.698 134.781 99.824 135.866 98.951 137.482H97.9756C97.6089 136.933 96.9874 136.586 96.2978 136.586C95.182 136.586 94.274 137.494 94.274 138.61C94.274 139.726 95.1817 140.634 96.2978 140.634C96.8159 140.634 97.2999 140.439 97.6681 140.097H109.65C110.019 140.439 110.505 140.634 111.021 140.634C112.137 140.634 113.045 139.726 113.045 138.61C113.045 137.494 112.137 136.586 111.021 136.586C110.332 136.586 109.711 136.933 109.344 137.482H108.481C107.608 135.866 105.734 134.781 103.716 134.781Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M95.6576 138.61C95.6576 138.256 95.9444 137.97 96.2981 137.97C96.6517 137.97 96.9385 138.256 96.9385 138.61C96.9385 138.964 96.6517 139.251 96.2981 139.251C95.9444 139.25 95.6576 138.964 95.6576 138.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M110.381 138.61C110.381 138.256 110.668 137.97 111.022 137.97C111.375 137.97 111.662 138.256 111.662 138.61C111.662 138.964 111.375 139.251 111.022 139.251C110.668 139.25 110.381 138.964 110.381 138.61Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M104.211 167.038L103.258 167.044V143.162L104.211 143.156V167.038Z",
    fill: "#C78872"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M97.8177 150.021L97.8115 149.068L109.753 149.067L109.758 150.021L97.8177 150.021Z",
    fill: "#C78872"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M97.8177 155.683L97.8115 154.73L109.752 154.73L109.758 155.683L97.8177 155.683Z",
    fill: "#C78872"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M97.8177 161.346L97.8115 160.392L109.752 160.392L109.758 161.345L97.8177 161.346Z",
    fill: "#C78872"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M161.614 64.8213C149.135 62.8123 145.864 73.1701 131.976 75.699C131.976 75.699 114.785 75.4995 117.386 80.9107C118.063 82.32 120.195 83.4947 121.947 83.9098C118.189 84.2746 115.426 84.711 115.426 84.711C95.8366 73.175 91.3493 78.5157 91.3493 78.5157L115.863 90.9247C115.863 90.9247 148.426 91.0788 149.074 91.0614C149.721 91.0439 160.252 76.8614 160.252 76.8614L223.46 102.45L228.534 86.5945C228.534 86.5945 165.377 65.4273 161.614 64.8213Z",
    fill: "#F58D6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M87.1688 78.39C90.1341 76.4468 97.8982 75.68 111.228 86.7475C111.228 86.7475 122.188 85.4789 131.995 90.7023C131.995 90.7023 158.904 66.6858 165.823 66.5586C172.742 66.4315 228.534 86.5942 228.534 86.5942L232.072 106.797L213.301 110.085L171.244 85.1307C171.244 85.1307 143.795 102.138 139.931 104.496C134.944 107.538 119.937 96.6174 110.032 94.5493C106.65 93.8432 91.8586 84.1728 87.193 81.0836C86.2324 80.4477 86.2054 79.0212 87.1688 78.39Z",
    fill: "#FFB287"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M173.983 93.2375L185.53 64.5847L234.144 83.5994L236.671 107.489L212.156 110.083L173.983 93.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M173.983 93.2375L190.492 66.5257L236.671 107.489L212.156 110.083L173.983 93.2375Z",
    fill: "#90AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M178.037 97.4311L191 65.2664L245 86.6116V127.191L178.037 97.4311Z",
    fill: "#BA4200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M188.327 94.9729C188.46 96.2322 187.547 97.3611 186.288 97.4945C185.028 97.6277 183.899 96.7149 183.766 95.4553C183.633 94.196 184.546 93.0671 185.805 92.9337C187.065 92.8006 188.193 93.7136 188.327 94.9729Z",
    fill: "#8E2F00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M195.255 98.2875C195.389 99.5468 194.476 100.676 193.216 100.809C191.957 100.942 190.828 100.029 190.695 98.7699C190.562 97.5106 191.474 96.3817 192.734 96.2483C193.993 96.1152 195.122 97.0282 195.255 98.2875Z",
    fill: "#8E2F00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M77.2232 25.9039C77.2232 25.9039 98.7097 30.4764 106.502 19.0216L118.487 19.2129C118.487 19.2129 127.227 36.0861 133.997 33.219C136.908 31.9864 132.862 28.8049 123.013 14.1417C123.013 14.1417 110.818 7.02853 92.5814 8.23202L77.2232 25.9039Z",
    fill: "#F58D6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M0 57.5149L39.5403 25.4237C40.5758 24.5901 41.5359 23.67 42.4517 22.7064C44.4073 20.6484 46.9066 18.9835 49.7505 17.8575C62.6587 12.7477 95.4248 0.480239 99.5827 0.0030332C101.643 -0.233528 117.299 13.4345 121.273 17.3803C121.988 18.09 122.491 18.9287 122.752 19.8407C124.062 24.4301 128.107 38.9716 127.08 40.1313C125.859 41.5101 119.965 42.5917 113.667 21.8837L98.3999 18.0467L94.714 25.228C94.714 25.228 80.2628 42.1038 58.7905 35.2357L0 104.347V57.5149Z",
    fill: "#FFB287"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M40.9648 24.4271C40.9648 24.4271 48.2214 33.5563 58.2506 35.8661L54.0592 41.1241L39.3516 26.3089L40.9648 24.4271Z",
    fill: "#F58D6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M64.2689 50.7491L40.6953 24.2621L-3.05176e-05 57.9148V89.6725L29.547 83.734L64.2689 50.7491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M64.2689 50.7491L36.0852 28.2809L-3.05176e-05 90.4263L29.547 83.7339L64.2689 50.7491Z",
    fill: "#90AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M62.1143 56.5477L35.6513 26.8145L-3.05176e-05 55.4558V114.461L62.1143 56.5477Z",
    fill: "#374C58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M51.9825 57.8805C52.2149 58.8371 53.1791 59.424 54.1357 59.1912C55.0923 58.9585 55.6792 57.994 55.4465 57.0371C55.214 56.0805 54.2498 55.4936 53.2932 55.7264C52.3366 55.9594 51.7497 56.9236 51.9825 57.8805Z",
    fill: "#2A3C44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M47.7804 62.1241C48.0129 63.0807 48.9771 63.6676 49.9337 63.4349C50.8903 63.2021 51.4772 62.2377 51.2447 61.2811C51.012 60.3242 50.048 59.7376 49.0914 59.9703C48.1349 60.2028 47.5479 61.1673 47.7804 62.1241Z",
    fill: "#2A3C44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M96.1429 25.363L93.3319 22.0985C93.1484 21.9626 93.0551 21.073 93.7941 21.2979C95.4375 21.7982 95.5271 23.9708 98.429 18.3173L96.1429 25.363Z",
    fill: "#F58D6C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M124.787 50.7754L126.326 52.565C128.109 54.6396 131.392 54.9535 133.659 53.2663L135.088 52.2035C137.355 50.5163 137.747 47.4671 135.964 45.3925L134.425 43.6029C132.642 41.5283 129.358 41.2144 127.091 42.9014L125.663 43.9642C123.396 45.6514 123.004 48.7008 124.787 50.7754ZM127.171 44.1988C128.661 43.0906 130.198 44.8786 128.709 45.987C127.219 47.095 125.682 45.307 127.171 44.1988Z",
    fill: "#102333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M132.454 46.5838L140.055 55.4258L141.041 54.7894L141.6 55.4397L141.275 56.8449L141.452 57.0515L142.438 56.4151L142.997 57.0651L142.672 58.4706L142.85 58.677L143.835 58.0405L144.395 58.6909L144.07 60.0961L144.51 60.6081L144.03 64.2837L140.155 63.8487L128.099 49.824L132.454 46.5838Z",
    fill: "#819DA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M143.511 59.4443L143.951 59.9591L143.47 63.6344L139.597 63.198L135.298 58.197L134.234 56.9603L127.541 49.1739L131.893 45.9326L138.051 53.0937L139.113 54.3309L139.497 54.7749L141.039 54.7896L140.715 56.1954L140.892 56.4009L142.438 56.4153L142.113 57.8213L142.291 58.0269L143.836 58.0413L143.511 59.4443Z",
    fill: "#C8D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M139.113 54.3309C137.852 55.6333 136.581 56.92 135.299 58.1973L134.234 56.9603C135.517 55.6831 136.79 54.3933 138.052 53.0937L139.113 54.3309Z",
    fill: "#D4E8E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M142.132 62.6288L140.174 62.0446L128.814 48.8304L129.702 48.1692L142.132 62.6288Z",
    fill: "#819DA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M142.932 62.034L142.749 60.1276L131.39 46.9134L130.501 47.5744L142.932 62.034Z",
    fill: "#819DA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M135.162 44.4917L133.624 42.7027C131.841 40.6275 128.559 40.315 126.29 42.0004L124.861 43.0631C122.671 44.6935 122.231 47.5981 123.816 49.664C123.87 49.735 123.926 49.8055 123.986 49.876L125.524 51.6651C126.398 52.684 127.636 53.2785 128.937 53.4174C130.286 53.5649 131.704 53.226 132.858 52.3674L134.287 51.3046C136.553 49.6169 136.945 46.5669 135.162 44.4917ZM128.504 45.7791C127.015 46.8892 125.198 44.7765 126.688 43.6664C128.177 42.559 129.994 44.6717 128.504 45.7791ZM128.937 53.4171C127.636 53.2783 126.399 52.6837 125.524 51.6648L123.986 49.8757C123.926 49.8055 123.87 49.735 123.816 49.664C123.907 48.6908 124.067 47.4881 124.058 47.3988C124.043 47.2635 123.979 46.0028 123.979 46.0028C125.674 46.6368 127.777 48.9205 128.937 53.4171Z",
    fill: "#1F3242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M128.756 45.999C129.538 45.4173 129.673 44.3659 129.058 43.6508C128.443 42.9357 127.311 42.8273 126.529 43.4091",
    stroke: "#102333",
    strokeWidth: 0.788083,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M121.298 46.2184C118.128 46.3564 115.647 49.0947 115.745 52.032C115.842 54.969 118.492 57.2383 121.662 57.1C124.832 56.962 127.323 54.4687 127.226 51.5317C127.128 48.5944 124.468 46.0801 121.298 46.2184ZM121.275 49.7764C119.031 49.8741 118.94 47.1462 121.184 47.0484C123.428 46.9507 123.519 49.6786 121.275 49.7764Z",
    fill: "#602812"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M123.124 67.5648C122.766 67.3587 122.75 66.8793 123.094 66.6425L124.357 65.7738L124.335 65.1273L123.018 64.3708C122.66 64.165 122.644 63.6853 122.988 63.4488L124.251 62.5801L123.916 52.5152C123.888 51.6749 123.13 51.0259 122.224 51.0654L120.76 51.1291C119.853 51.1685 119.14 51.8818 119.168 52.7218L119.703 68.8407C119.715 69.2128 119.875 69.5653 120.15 69.8321L120.907 70.5646C121.583 71.2188 122.734 71.1687 123.365 70.4577L124.071 69.6611C124.329 69.3712 124.464 69.0056 124.451 68.6335L124.441 68.321L123.124 67.5648Z",
    fill: "#819DA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M123.893 51.7963L123.942 53.2638L124.03 55.9618L124.12 58.6214L124.194 60.8746L124.227 61.862L122.964 62.7293C122.619 62.9656 122.634 63.4458 122.995 63.6513L124.31 64.4072L124.332 65.0538L123.069 65.9238C122.727 66.1598 122.742 66.64 123.101 66.8458L124.418 67.6015L124.426 67.9154C124.438 68.2864 124.305 68.6536 124.048 68.9436L123.341 69.7382C122.71 70.4509 121.56 70.4988 120.883 69.8449L120.127 69.1118C119.849 68.8456 119.692 68.4928 119.68 68.1217L119.592 65.5032L119.519 63.2854L119.284 56.2558L119.201 53.7408L119.143 52.0032C119.115 51.1631 119.828 50.4499 120.735 50.4085L122.198 50.3467C123.106 50.3056 123.865 50.9562 123.893 51.7963Z",
    fill: "#C8D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M124.12 58.6214L124.194 60.8746C122.676 62.4369 121.141 63.9788 119.592 65.5032L119.519 63.2854C121.067 61.7474 122.6 60.1919 124.12 58.6214Z",
    fill: "#D4E8E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M123.942 53.2641L124.03 55.9621C121.96 56.9693 119.745 56.3935 119.284 56.2561L119.201 53.741C119.625 53.6852 120.318 53.612 121.279 53.3215C122.923 52.8241 123.19 53.1437 123.942 53.2641Z",
    fill: "#819DA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M121.482 69.0723L120.531 67.8315L119.948 51.7353L120.852 51.6931L121.482 69.0723Z",
    fill: "#819DA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M121.301 45.3256C119.767 45.392 118.392 46.0083 117.395 46.9597C117.029 47.3079 116.718 47.6993 116.461 48.1235C115.97 48.9445 115.704 49.8926 115.736 50.8939C115.833 53.829 118.482 56.1001 121.654 55.9616C124.823 55.8235 127.316 53.3289 127.216 50.3938C127.119 47.456 124.47 45.1875 121.301 45.3256ZM121.296 49.5472C120.53 49.5818 120.011 49.226 119.754 48.7387C119.583 48.4226 119.525 48.051 119.581 47.695C119.682 46.9997 120.215 46.366 121.19 46.323C123.433 46.2253 123.541 49.4495 121.296 49.5472Z",
    fill: "#89351B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M119.754 48.7386C118.898 48.7443 117.58 48.6839 116.461 48.1234C116.717 47.6993 117.029 47.3078 117.395 46.9597C118.049 47.2381 118.894 47.595 119.001 47.6247C119.08 47.6492 119.325 47.6614 119.581 47.6949C119.525 48.051 119.583 48.4226 119.754 48.7386Z",
    fill: "#602812"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M124.438 55.303C123.622 55.7138 122.673 55.9691 121.655 56.0135C120.567 56.0609 119.541 55.8611 118.66 55.4751",
    stroke: "#602812",
    strokeWidth: 0.240536,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M121.375 49.6822C120.372 49.7883 119.48 49.1219 119.382 48.1942C119.283 47.2665 120.017 46.4283 121.019 46.3221",
    stroke: "#602812",
    strokeWidth: 0.322148,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M126.691 45.7578C129.355 43.255 129.668 39.2732 127.285 36.5004C124.714 33.5106 119.982 33.0579 116.714 35.4893C113.447 37.9208 112.882 42.3159 115.452 45.306C117.287 47.4399 120.223 48.2813 122.941 47.7042",
    stroke: "#DFEDED",
    strokeWidth: 0.87043,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M126.529 43.4088C125.748 43.9906 125.613 45.0419 126.228 45.757C126.842 46.4721 127.974 46.5805 128.756 45.9987",
    stroke: "#102333",
    strokeWidth: 0.788083,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M129.85 53.5728C130.878 53.4557 131.937 53.052 132.867 52.36L134.295 51.2973C135.161 50.6526 135.79 49.8515 136.154 49.0114",
    stroke: "#102333",
    strokeWidth: 0.320351,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M121.019 46.3225C122.022 46.2163 122.914 46.8824 123.013 47.8104C123.111 48.7382 122.377 49.5763 121.375 49.6825",
    stroke: "#602812",
    strokeWidth: 0.322148,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M54.7559 34.7982C54.7559 34.7982 67.3156 37.9413 81.6642 37.0998C89.7451 36.6259 97.816 37.7344 105.411 40.2021C107.295 40.8143 109.108 41.4059 110.646 41.9122C117.426 44.1436 122.094 49.2603 124.343 44.151C126.593 39.0416 115.98 33.4913 107.121 31.2985C98.2624 29.1058 92.1317 16.2063 92.1317 16.2063L54.7559 34.7982Z",
    fill: "#FFB287"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuysell2);
export default __webpack_public_path__ + "static/media/buysell2.f6cfb20b1784cd275a12501571f623f1.svg";
export { ForwardRef as ReactComponent };